(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq_complete_section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.step').forEach(step => {
  step.querySelector('.step-header').addEventListener('click', () => {
    step.classList.toggle('active');
    const icon = step.querySelector('.toggle-icon');
    icon.textContent = step.classList.contains('active') ? '-' : '+';
  });
});

  } catch(e) { console.error(e); }
})();
})();
